import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import NavBar from "@/components/NavBar";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      const dest = loc.state?.from || (u.onboarded ? "/dashboard" : "/onboarding");
      nav(dest, { replace: true });
    } catch (e) {
      setErr(formatErr(e));
    } finally { setLoading(false); }
  };

  return (
    <div className="App" data-testid="page-login">
      <NavBar />
      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-24 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <div className="aa-eyebrow mb-4">Welcome back</div>
          <h1 className="font-display text-4xl lg:text-5xl leading-tight">Pick up where your skin left off.</h1>
          <p className="mt-5 text-[var(--aa-text-2)] max-w-md">Sign in to your Ageless Alchemy companion to view your protocol, saved products, and ongoing analysis.</p>
        </div>
        <form onSubmit={submit} className="aa-card p-8 lg:p-10 space-y-5">
          <div>
            <label className="aa-eyebrow block mb-2">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-[var(--aa-elevated)] focus:border-[var(--aa-text)] outline-none py-3 text-base" />
          </div>
          <div>
            <label className="aa-eyebrow block mb-2">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border-b border-[var(--aa-elevated)] focus:border-[var(--aa-text)] outline-none py-3 text-base" />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-[var(--aa-terra)]">{err}</div>}
          <button data-testid="login-submit" disabled={loading} className="aa-cta-primary w-full">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-sm text-[var(--aa-text-3)] flex flex-wrap items-center justify-between gap-3">
            <Link to="/forgot-password" data-testid="login-to-forgot" className="underline underline-offset-4">Forgot password?</Link>
            <span>
              New here?{" "}
              <Link to="/register" data-testid="login-to-register" className="underline underline-offset-4">Create an account</Link>
            </span>
          </div>
        </form>
      </section>
    </div>
  );
}
